var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function series(_x) {
  return _series.apply(this, arguments);
}

function _series() {
  _series = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(array) {
    var results, i;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            results = [];
            i = 0;

          case 2:
            if (!(i !== array.length)) {
              _context.next = 11;
              break;
            }

            _context.t0 = results;
            _context.next = 6;
            return array[i]();

          case 6:
            _context.t1 = _context.sent;

            _context.t0.push.call(_context.t0, _context.t1);

          case 8:
            i++;
            _context.next = 2;
            break;

          case 11:
            return _context.abrupt("return", results);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _series.apply(this, arguments);
}

function parallel(array) {
  return Promise.all(array.map(function (func) {
    return func();
  }));
}

module.exports = {
  series: series,
  parallel: parallel
};